import { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Mail, CheckCircle, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function NewsletterSignup({ source = 'homepage', variant = 'default' }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await fetch(`${API_URL}/api/newsletter/subscribe/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, first_name: name, source }),
      });
      setSubscribed(true);
      toast.success('Subscribed! Check your inbox for STEM tips.');
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <div className="flex items-center gap-2 text-emerald-400" data-testid="newsletter-success">
        <CheckCircle className="w-5 h-5" />
        <span className="text-sm font-medium">You're in! Watch for our next STEM newsletter.</span>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <form onSubmit={handleSubmit} className="flex gap-2 max-w-sm" data-testid="newsletter-form">
        <Input
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className="bg-white/10 border-white/20 text-white placeholder:text-white/40 text-sm"
          data-testid="newsletter-email"
        />
        <Button type="submit" disabled={loading} size="sm" className="bg-rsc-yellow text-rsc-navy font-bold whitespace-nowrap" data-testid="newsletter-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Mail className="w-3.5 h-3.5 mr-1" /> Subscribe</>}
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3 max-w-md" data-testid="newsletter-form">
      <div className="flex gap-2">
        <Input
          type="text"
          placeholder="First name"
          value={name}
          onChange={e => setName(e.target.value)}
          className="bg-white/10 border-white/20 text-white placeholder:text-white/40"
          data-testid="newsletter-name"
        />
        <Input
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className="bg-white/10 border-white/20 text-white placeholder:text-white/40"
          data-testid="newsletter-email"
        />
      </div>
      <Button type="submit" disabled={loading} className="w-full bg-rsc-yellow text-rsc-navy font-bold hover:bg-rsc-yellow/90" data-testid="newsletter-submit">
        {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}
        Get Free STEM Tips & Updates
      </Button>
      <p className="text-[11px] text-white/30">No spam. Unsubscribe anytime. We respect your inbox.</p>
    </form>
  );
}
